import { Alert, Divider, Paper, Typography } from "@mui/material";
import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ProjectApplicationDetails from "../../components/projects/ProjectApplicationDetails";
import useProjectsDetails from "../../hooks/projects/useProjectsDetails";
import LoadingCircle from "../../components/general/LoadingCircle";
import { AuthContext } from "../../context/auth-context/AuthContext";
import { doesPermissionsHaveSomeOf } from "../../utils/authUtils";

/**
 * Project Application Details Page
 * @returns Project Application Details Page
 */
const ProjectApplicationDetailsPage = () => {
  const { id, memberId } = useParams();
  const { projectApplications, isProjectApplicationsLoading, projectDetails, isProjectDetailsLoading } =
    useProjectsDetails(Number(id));
  const projectapplicant = projectApplications?.filter((applicant) => applicant.memberId === Number(memberId))[0];
  const { auth } = useContext(AuthContext);
  const navigate = useNavigate();
  const hasPermissionProjectApplications = doesPermissionsHaveSomeOf(auth?.permissions, [21]);

  if (
    projectDetails &&
    !projectDetails.staffingCommittee.some((member) => member.memberId === auth?.userID) &&
    !hasPermissionProjectApplications
  ) {
    navigate("/projekte");
    return <Alert severity="error">Du bist nicht teil des Besetzungsgremiums</Alert>;
  }

  if (isProjectDetailsLoading || isProjectApplicationsLoading) {
    return <LoadingCircle />;
  }

  if (!projectapplicant) {
    return <Alert severity="warning">Projektbewerbung nicht gefunden</Alert>;
  }

  if (projectDetails && projectDetails.status !== "Bewerbung" && !hasPermissionProjectApplications) {
    navigate(`/projekte/${id}`);
    return <Alert severity="warning">Projekt ist nicht in der Bewerbungsphase</Alert>;
  }

  return (
    <Paper sx={{ p: 2, flex: 1 }}>
      <Typography variant="h6" fontWeight={"bold"}>
        {projectapplicant.firstname} {projectapplicant.lastname} - {projectapplicant.memberStatus.name}
      </Typography>
      <Divider sx={{ my: 2 }} />
      <ProjectApplicationDetails projectApplication={projectapplicant} />
    </Paper>
  );
};

export default ProjectApplicationDetailsPage;
